module.exports = __webpack_public_path__ + "media/09. Scattle - Knock Knock.f4e2e38b.mp3";